import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_ASP_URL;
const BASE_URL = process.env.REACT_APP_API_URL;

export const GetSaleOrderFileApi = async (id) => {
  try {
    window.open(`${API_URL}/saleorder/file/${id}`, "_blank");
    // const { data } = await axiosInstance.get(`/saleorder/file/${id}`, { responseType: "blob" });
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintSalesOrderApi = async (id, showPrice) => {
  try {
    if (showPrice)
      window.open(`${API_URL}/report/so/${id}`, "_blank");
    else
      window.open(`${API_URL}/report/so_no/${id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintQuoteApi = async (id, showPrice) => {
  try {
    if (showPrice)
      window.open(`${API_URL}/report/qu/${id}`, "_blank");
    else
      window.open(`${API_URL}/report/qu_no/${id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintPurchaseOrderApi = async (id) => {
  try {
    window.open(`${API_URL}/report/po/${id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintPackingListApi = async (id) => {
  try {
    window.open(`${API_URL}/report/pl/${id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintProformaInvoiceApi = async (id, proforma, deposit, note, showPrice) => {
  try {
    const params = new URLSearchParams({ proforma: proforma, deposit: deposit, note: note });
    if (showPrice)
      window.open(`${API_URL}/report/pf/${id}?${params}`, "_blank");
    else
      window.open(`${API_URL}/report/pf_no/${id}?${params}`, "_blank");
    // const { data } = await axiosInstance.get(`/report/PF/${id}`, {
    //   params: { proforma: proforma, note: note }, responseType: "blob"
    // });
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintKitApi = async (id) => {
  try {
    window.open(`${API_URL}/report/kit/${id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintBoxQrCodeApi = async (so_id, box_id) => {
  try {
    window.open(`${API_URL}/report/Print/boxqrcode/${so_id}/${box_id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintGpuStickerApi = async (gpu_sns) => {
  try {
    window.open(`${API_URL}/report/Print/GpuSticker/${gpu_sns}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintGpuRollerApi = async (gpu_sns) => {
  try {
    window.open(`${API_URL}/report/Print/GpuRoller/${gpu_sns}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintRMACodeApi = async (gpu_sns) => {
  try {
    window.open(`${API_URL}/report/Print/RMACode/${gpu_sns}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintRMAIDApi = async (gpu_sns) => {
  try {
    window.open(`${API_URL}/report/Print/RMA/${gpu_sns}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintRecvWBApi = async (part_id, dateF, dateT) => {
  try {
    window.open(`${API_URL}/report/Print/recvWB/${part_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintRecvGPUApi = async (so_id, status_id, part_id, dateF, dateT) => {
  try {
    window.open(`${API_URL}/report/Print/recvGPU/${so_id}/${status_id}/${part_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintTestGPUApi = async (so_id, dateF, dateT) => {
  try {
    window.open(`${API_URL}/report/Print/testGPU/${so_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintTestDetailGPUApi = async (so_id, dateF, dateT) => {
  try {
    window.open(`${API_URL}/report/Print/testDetailGPU/${so_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintLogGPUApi = async (so_id) => {
  try {
    window.open(`${API_URL}/report/Print/logGPU/${so_id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintShipAssyApi = async (so_id, dateF, dateT) => {
  try {
    window.open(`${API_URL}/report/Print/shipAssy/${so_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const GenerateGpuWbExcelApi = async (type, so_id, status_id, part_id, dateF, dateT) => {
  try {
    // if (type == "LGP") window.open(`${API_URL}/report/GpuWbExcel/${type}/${so_id}`, "_blank");
    // else
    window.open(`${API_URL}/report/GpuWbExcel/${type}/${so_id}/${status_id}/${part_id}/${dateF}/${dateT}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintSystemBuildApi = async (so_part_id) => {
  try {
    window.open(`${API_URL}/report/Print/systemBuild/${so_part_id}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const PrintSystemBuildBySnApi = async (so_part_id, sn) => {
  try {
    window.open(`${API_URL}/report/Print/systemBuildSn/${so_part_id}/${sn}`, "_blank");
    return true;
  } catch (err) {
    return false;
  }
};

export const GetInvStkReport = async (
  dateFrom,
  dateTo,
  store_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/inventoryStockReport`,
      { date_from: dateFrom, date_to: dateTo, store_id: store_id },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetInvLedReport = async (
  dateFrom,
  dateTo,
  part_id,
  store_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/inventoryLedgerReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        part_id: part_id,
        store_id: store_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetInvPrfReport = async (
  dateFrom,
  dateTo,
  part_id,
  store_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/inventoryProfitReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        part_id: part_id,
        store_id: store_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAccLedgerReport = async (
  dateFrom,
  dateTo,
  store_id,
  account_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/accountLedgerReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        account_id: account_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAccLedgerSummaryReport = async (
  dateFrom,
  dateTo,
  store_id,
  account_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/accountLedgerSummaryReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        account_id: account_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSummaryReport = async (
  dateFrom,
  dateTo,
  store_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/summaryReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSaleInvoice = async (store_id, so_id, type) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/saleInvoice`,
      {
        store_id: store_id,
        so_id: so_id,
        type: type,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetGenerateInvoice = async (
  store_id,
  so_id,
  type
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/invoice/generateInvoice`,
      {
        store_id: store_id,
        so_id: so_id,
        type: type,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetGenerateQuote = async (store_id, so_id) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/invoice/generateQuote`,
      { store_id: store_id, so_id: so_id },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetGeneratePackingList = async (
  store_id,
  so_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/invoice/generatePackingList`,
      { store_id: store_id, so_id: so_id },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSaleDetailReport = async (
  dateFrom,
  dateTo,
  store_id,
  part_id,
  customer_id,
  vendor_id,
  uuser_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/saleDetailReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        part_id: part_id,
        customer_id: customer_id,
        vendor_id: vendor_id,
        uuser_id: uuser_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSaleSummaryReport = async (
  dateFrom,
  dateTo,
  store_id,
  part_id,
  customer_id,
  vendor_id,
  uuser_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/saleSummaryReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        part_id: part_id,
        customer_id: customer_id,
        vendor_id: vendor_id,
        uuser_id: uuser_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPurchaseDetailReport = async (
  dateFrom,
  dateTo,
  store_id,
  part_id,
  vendor_id,
  uuser_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/purchaseDetailReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        part_id: part_id,
        vendor_id: vendor_id,
        uuser_id: uuser_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPurchaseSummaryReport = async (
  dateFrom,
  dateTo,
  store_id,
  part_id,
  vendor_id,
  uuser_id
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/purchaseSummaryReport`,
      {
        date_from: dateFrom,
        date_to: dateTo,
        store_id: store_id,
        part_id: part_id,
        vendor_id: vendor_id,
        uuser_id: uuser_id,
      },
      { responseType: "blob" } // Receive the response as a Blob (binary data)
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAccountListforRep = async (store_id) => {
  try {
    //console.log("GetAllAccounts");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/getAccountListforRep`,
      {
        store_id: store_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPartListforRep = async (store_id) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/report/getPartListforRep`,
      {
        store_id: store_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
